/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CancelAllResponse,
  CancelByGroupRequest,
  CancelByGroupResponse,
  CancelByIdsRequest,
  CancelByIdsResponse,
  ProcessingState,
  PurgeQueueRequest,
  PurgeQueueResponse,
  StopWorkerResponse,
  Task,
} from "../models/index";
import {
  CancelAllResponseFromJSON,
  CancelAllResponseToJSON,
  CancelByGroupRequestFromJSON,
  CancelByGroupRequestToJSON,
  CancelByGroupResponseFromJSON,
  CancelByGroupResponseToJSON,
  CancelByIdsRequestFromJSON,
  CancelByIdsRequestToJSON,
  CancelByIdsResponseFromJSON,
  CancelByIdsResponseToJSON,
  ProcessingStateFromJSON,
  ProcessingStateToJSON,
  PurgeQueueRequestFromJSON,
  PurgeQueueRequestToJSON,
  PurgeQueueResponseFromJSON,
  PurgeQueueResponseToJSON,
  StopWorkerResponseFromJSON,
  StopWorkerResponseToJSON,
  TaskFromJSON,
  TaskToJSON,
} from "../models/index";

export interface CancelQueueTasksByGroupRequest {
  cancelByGroupRequest: CancelByGroupRequest;
}

export interface CancelQueueTasksByIdsRequest {
  cancelByIdsRequest: CancelByIdsRequest;
}

export interface ListQueueTasksRequest {
  state?: ProcessingState | null;
  limit?: number | null;
  cursor?: string | null;
}

export interface PurgeQueueOperationRequest {
  purgeQueueRequest: PurgeQueueRequest;
}

/**
 *
 */
export class QueueApi extends runtime.BaseAPI {
  /**
   */
  async cancelAllQueueTasksRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CancelAllResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/queue/cancel-all-queue-tasks`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CancelAllResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async cancelAllQueueTasks(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CancelAllResponse> {
    const response = await this.cancelAllQueueTasksRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async cancelQueueTasksByGroupRaw(
    requestParameters: CancelQueueTasksByGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CancelByGroupResponse>> {
    if (requestParameters["cancelByGroupRequest"] == null) {
      throw new runtime.RequiredError(
        "cancelByGroupRequest",
        'Required parameter "cancelByGroupRequest" was null or undefined when calling cancelQueueTasksByGroup().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/queue/cancel-queue-tasks-by-group`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CancelByGroupRequestToJSON(
          requestParameters["cancelByGroupRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CancelByGroupResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async cancelQueueTasksByGroup(
    requestParameters: CancelQueueTasksByGroupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CancelByGroupResponse> {
    const response = await this.cancelQueueTasksByGroupRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async cancelQueueTasksByIdsRaw(
    requestParameters: CancelQueueTasksByIdsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CancelByIdsResponse>> {
    if (requestParameters["cancelByIdsRequest"] == null) {
      throw new runtime.RequiredError(
        "cancelByIdsRequest",
        'Required parameter "cancelByIdsRequest" was null or undefined when calling cancelQueueTasksByIds().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/queue/cancel-queue-tasks-by-ids`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CancelByIdsRequestToJSON(requestParameters["cancelByIdsRequest"]),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CancelByIdsResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async cancelQueueTasksByIds(
    requestParameters: CancelQueueTasksByIdsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CancelByIdsResponse> {
    const response = await this.cancelQueueTasksByIdsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getQueueStatusRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<{ [key: string]: number }>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/queue/queue-status`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async getQueueStatus(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<{ [key: string]: number }> {
    const response = await this.getQueueStatusRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async listQueueTasksRaw(
    requestParameters: ListQueueTasksRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Task>>> {
    const queryParameters: any = {};

    if (requestParameters["state"] != null) {
      queryParameters["state"] = requestParameters["state"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["cursor"] != null) {
      queryParameters["cursor"] = requestParameters["cursor"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/queue/list-queue-tasks`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(TaskFromJSON),
    );
  }

  /**
   */
  async listQueueTasks(
    requestParameters: ListQueueTasksRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Task>> {
    const response = await this.listQueueTasksRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async purgeQueueRaw(
    requestParameters: PurgeQueueOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PurgeQueueResponse>> {
    if (requestParameters["purgeQueueRequest"] == null) {
      throw new runtime.RequiredError(
        "purgeQueueRequest",
        'Required parameter "purgeQueueRequest" was null or undefined when calling purgeQueue().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/queue/purge-queue`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PurgeQueueRequestToJSON(requestParameters["purgeQueueRequest"]),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PurgeQueueResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async purgeQueue(
    requestParameters: PurgeQueueOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PurgeQueueResponse> {
    const response = await this.purgeQueueRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async stopQueueWorkerRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<StopWorkerResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/queue/stop-queue-worker`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StopWorkerResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async stopQueueWorker(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<StopWorkerResponse> {
    const response = await this.stopQueueWorkerRaw(initOverrides);
    return await response.value();
  }
}
